import { useMutation, useQuery } from "@tanstack/react-query";
import { useDataService } from "@/lib/dataService";

// Infringements
export function useInfringementsQuery(params?: {
  lastseen_from?: string;
  lastseen_to?: string;
}) {
  const ds = useDataService();
  return useQuery({
    queryKey: ["infringements", params],
    queryFn: () => ds.getInfringements(params),
    staleTime: 30000,
    refetchInterval: 60000,
  });
}

// Infringement actions
export function useInfringementActionMutation() {
  const ds = useDataService();
  return useMutation({
    mutationFn: ({ id, action }: { id: string; action: "block" | "ignore" }) =>
      ds.triggerInfringementAction(id, action),
  });
}

// EDR
export function useEdrsQuery() {
  const ds = useDataService();
  return useQuery({
    queryKey: ["edrs"],
    queryFn: () => ds.getEdrs(),
    staleTime: 60000,
    refetchInterval: 30000,
  });
}

// User account
export function useAccountQuery(enabled = true) {
  const ds = useDataService();
  return useQuery({
    queryKey: ["account"],
    queryFn: async () => {
      const account = await ds.getAccount();
      return account;
    },
    staleTime: 5 * 60000,
    enabled,
  });
}

// Dashboards
export function useDashboardsQuery(enabled = true) {
  const ds = useDataService();
  return useQuery({
    queryKey: ["dashboards"],
    queryFn: () => ds.getDashboards(),
    staleTime: 60000,
    enabled,
  });
}

// Single dashboard
export function useDashboardQuery(id: string | undefined) {
  const ds = useDataService();
  return useQuery({
    queryKey: ["dashboards", id],
    queryFn: () => ds.getDashboard(id!),
    staleTime: 15000,
    refetchOnWindowFocus: true,
    enabled: !!id,
  });
}
